import { useState } from "react";
import { useChatbotContext } from "../contexts/chatbotContext";
import { Button } from "primereact/button";
import styled from "styled-components";

const StyledButton = styled(Button)`
  border-radius: 10px;
  background-color: var(--sumi-blue);
  color: #fff;
  width: 50px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 1000;

  & span {
    font-size: 1.5rem;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

const ChatbotButton: React.FC = () => {
  const [hover, setHover] = useState(false);

  const { isOpen, setIsOpen } = useChatbotContext();

  if (isOpen) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <StyledButton
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(true);
        }}
        className={`flex items-center justify-center rounded-full shadow-lg transition-all duration-300 ${
          hover ? "scale-110" : "scale-100"
        }`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        aria-label="Open chatbot"
        icon={isOpen ? "pi pi-times" : "pi pi-comments"}
        text
      />
    </div>
  );
};

export default ChatbotButton;
